import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { QuickFilters } from 'components/QuickFilters';
import { SearchBoxDesktop } from 'components/SearchBox/Search';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "ctlcrgm",
  propsAsIs: false
});
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1b972bo",
  propsAsIs: false
});
interface Props {
  hasSearchBox: boolean;
  hasFilters: boolean;
  customSearchBox?: React.ReactElement;
}
export const DesktopHeaderBottom: React.FC<Props> = ({
  hasSearchBox,
  hasFilters,
  customSearchBox
}) => {
  const {
    brandHasCollapsingHeader
  } = useBrand();
  return <ContentWrapper className={cx(!brandHasCollapsingHeader && '__isFullWidth')}>
      {hasSearchBox && <Wrapper className={cx(brandHasCollapsingHeader && '__withTopPadding', !hasFilters && '__withBottomPadding')}>
          {customSearchBox ? customSearchBox : <SearchBoxDesktop />}
        </Wrapper>}
      {hasFilters && <QuickFilters />}
    </ContentWrapper>;
};

require("./DesktopHeaderBottom.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./DesktopHeaderBottom.tsx");